import { GraphQLClient } from "graphql-request"

const API_URL =
  process.env.NEXT_PUBLIC_SHOP_API ?? "http://localhost:3000/shop-api"

export const graphqlClient = new GraphQLClient(API_URL)

/**
 * Sets the languageCode to be used for all subsequent requests.
 */
export function setLanguageCode(languageCode: string | undefined) {
  if (!languageCode) {
    graphqlClient.setEndpoint(API_URL)
  } else {
    graphqlClient.setEndpoint(`${API_URL}?languageCode=${languageCode}`)
  }
}
